var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tigan-title"},[_c('span',[_vm._v(_vm._s(_vm.index + 1)+". ")]),_vm._v(_vm._s(_vm.topic.tag.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }